import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { FileText } from "lucide-react";
import type { CaseAnalysisItem } from "@/components/types";
import { renderTextWithBold } from "../utils/renderTextWithBold";

interface CaseAnalysisItemRendererProps {
  item: CaseAnalysisItem;
  onDocumentClick: (documentId: string) => void;
  index: number;
}

const CaseAnalysisItemRenderer = ({ item, onDocumentClick, index }: CaseAnalysisItemRendererProps) => {
  const handleDocumentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if ("document_id" in item && item.document_id) {
      onDocumentClick(item.document_id);
    }
  };

  if (item.type === "conclusion") {
    return (
      <Card className="mb-6 bg-slate-50 rounded-lg">
        <CardContent className="p-4">
          <h3 className="text-lg max-md:text-base font-semibold text-slate-800 text-right mb-3">מסקנה</h3>
          <p className="text-base max-sm:text-sm text-slate-600 text-right leading-relaxed">
            {renderTextWithBold(item.text)}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="mb-8 max-md:mb-6 max-sm:mb-4 p-4 max-md:p-3 max-sm:p-2 rounded-lg">
      <h3 className="text-lg max-md:text-base font-semibold text-indigo-900 text-right mb-3 flex items-center justify-start gap-3">
        <Badge className="bg-indigo-100 text-indigo-700 border-indigo-200 text-sm font-medium px-3 py-1 rounded-full">
          {index + 1}
        </Badge>
        {renderTextWithBold(item.title)}
      </h3>
      <p className="text-base max-sm:text-sm text-slate-600 text-right leading-relaxed">
        {renderTextWithBold(item.text)}
      </p>

      {/* Document navigation icon */}
      {"document_id" in item && item.document_id && (
        <div className="flex justify-start">
          <button
            onClick={handleDocumentClick}
            className="flex items-center gap-2 px-3 py-2 text-sm text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50 rounded-lg transition-colors duration-200"
            aria-label="צפה בסימוכין"
          >
            <FileText className="w-4 h-4" />
            <span>צפה בסימוכין</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default CaseAnalysisItemRenderer;
